/**
 * logs an error to the console if the condition passed is true.
 */
export default function warning(condition: unknown, message: string): void {
  // Wrapped in production check for better dead code elimination.
  if (__DEV__) {
    // Condition passed, do not log
    if (condition) return;

    // Condition not passed
    const text = `Warning: ${message}`;

    if (typeof console !== 'undefined') {
      console.error(text);
    }

    /**
     * Throwing an error and catching it immediately to improve
     * debugging. A consumer can use 'pause on caught exceptions'.
     * @see https://github.com/facebook/react/issues/4216
     */
    try {
      throw Error(text);
      // eslint-disable-next-line no-empty
    } catch (x) {}
  }
}
